export default __webpack_public_path__ + "static/media/Inter-ExtraBold.55189ddf.ttf";